module.exports = __webpack_public_path__ + "img/close-white.a889b88f.svg";